<div class="legacy-xref-editor">
  <wc-grid
    [gridKey]="gridKey"
    [context]="gridContext"
    [contextMenuItems]="rowActions"
    [showQuickSearch]="true"
    searchPlaceholder="Search by Source Id or Target Id..."
    (contextMenuAction)="onRowAction($event)">
  </wc-grid>
</div>
